<template>
	<div class="mt6 xs-12 wrap">
		<div class="xs-12 fs4 fw7 lh125 p1 mt2">{{ $t("type") }}</div>
		<j-base-input-text
			size="medium"
			v-model="inputType"
			@input="onInputChange"
		/>
		<div class="xs-12 fs4 fw7 lh125 p1 mt2">{{ $t("fields") }}</div>
		<j-input-object-list
			size="medium"
			v-model="inputValue"
			@input="onInputChange"
		/>
	</div>
</template>

<script>
import JBaseInputText from "@/components/JBaseInputText"
import JInputObjectList from "@/components/JInputObjectList"

export default {
	name: "InputNewAddress",
	components: {
		JBaseInputText,
		JInputObjectList
	},
	props: {
		value: {
			required: false
		}
	},
	data() {
		return {
			inputValue: [{ type: "", value: "" }],
			inputType: ""
		}
	},

	methods: {
		onInputChange() {
			this.$emit("input", {
				fields: this.inputValue,
				type: this.inputType
			})
		}
	}
}
</script>
